export const DimensionsList = {
    dimensions: [
        { id: 1, label: "platforms", value: "Platforms" },
        { id: 2, label: "countries", value: "Countries" },
        { id: 3, label: "languages", value: "Languages" },
        { id: 4, label: "post_types", value: "Post Types" },
        { id: 5, label: "sentiments", value: "Sentiments" },
        { id: 6, label: "published_date", value: "Published Date" },
        { id: 7, label: "topics_data", value: "Topics" },
        { id: 7, label: "sub_topics_data", value: "Sub Topics" },
        { id: 11, label: "entity_types", value: "Entity Types" },
        { id: 8, label: "entity_sub_type", value: "Entity SubType" },
        { id: 9, label: "product_attributes", value: "Product Attributes" },
        { id: 10, label: "wordclouds", value: "Top Keywords" },
        { id: 11, label: "moments", value: "Moments" },
        { id: 12, label: "top_influencers", value: "Top Influencers" },
        { id: 13, label: "wordclouds", value: "Top Positive Keyword" },
        { id: 14, label: "wordclouds", value: "Top Negative Keyword" },
    ],
};

export const MetricsList = {
    metrics: [
        { id: 7, label: "share_count", value: "Share Count" },
        { id: 8, label: "view_count", value: "View Count" },
        { id: 9, label: "like_count", value: "Like Count" },
        { id: 10, label: "mention", value: "Volume of Conversation" },
        { id: 11, label: "impact_value", value: "Impact Value" },
        { id: 12, label: "enagagment_value", value: "Engagement Value" },
        { id: 13, label: "estimated_reach", value: "Estimated Reach" },
        { id: 14, label: "comment_count", value: "Comment Count" },
        { id: 15, label: "unique_user", value: "Unique User" },
        { id: 16, label: "sentiment", value: "Net Sentiment" },
        // { id: 14, label: "Net Sentiment" },
        // { id: 15, label: "Moments Analysis" },
        // { id: 16, label: "Impact Analysis" },
        // { id: 17, label: "Product Attributes" },
        // { id: 18, label: "Scenes" },
        // { id: 19, label: "News Sources" },
        // { id: 20, label: "Date" },
        // { id: 21, label: "Topics" },
        // { id: 22, label: "Sub-Topics" },
        // { id: 23, label: "Top Topics" },
        // { id: 24, label: "Platforms" },
        // { id: 25, label: "Wordcloud" },
        // { id: 26, label: "Sentiment" },
        // { id: 27, label: "Entity" },
        // { id: 28, label: "Top Keywords negative" },
        // { id: 29, label: "Top Keywords positive" },
        // { id: 30, label: "Country" },
    ],
};

export const metricsNameObj = {
    share_count: "Share Count",
    view_count: "View Count",
    like_count: "Like Count",
    mention: "Volume of Conversation",
    impact_value: "Impact Value",
    enagagment_value: "Engagement Value",
    estimated_reach: "Estimated Reach",
    comment_count: "Comment Count",
    unique_user: "Unique User",
    sentiment: "Net Sentiment",
};

export const dimensionNameObj = {
    platforms: "Platforms",
    countries: "Countries",
    languages: "Languages",
    post_types: "Post Types",
    sentiments: "Sentiments",
    published_date: "Published Date",
    sub_topics_data: "Sub Topics",
    entity_types: "Entity Types",
    entity_sub_type: "Entity SubType",
    product_attributes: "Product Attributes",
    wordclouds: "Top Keywords",
    topics_data: "Topics",
    top_influencers: "Top Influencers",
    moments: "Moments",
};
